import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class BackupPageController implements angular.IComponentController {

    static $inject = [];
}

export const wtBackupPage: ComponentDefinition = {
    componentId: 'wtBackupPage',
    controller: BackupPageController,
    controllerAs: 'vm',
    template: require('./backupPage.component.html'),
    bindings: {

    }
};
